import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { contextConnect, useContextSystem } from '@wp-g2/context';
import React from 'react';
import { CardFooter } from '../Card';

function ModalFooter(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'ModalFooter'),
      children = _useContextSystem.children,
      _useContextSystem$jus = _useContextSystem.justify,
      justify = _useContextSystem$jus === void 0 ? 'flex-start' : _useContextSystem$jus,
      otherProps = _objectWithoutProperties(_useContextSystem, ["children", "justify"]);

  return /*#__PURE__*/React.createElement(CardFooter, Object.assign({
    direction: "row-reverse",
    justify: justify
  }, otherProps, {
    ref: forwardedRef
  }), children);
}

export default contextConnect(ModalFooter, 'ModalFooter');